@layer module {
.account-create-label {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
    }

.account-create-title {
            text-align: left;
    }

.account-close-identity {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
    }

.account-close-consequences {
            display: flex;
            flex-direction: column;
            list-style: disc;
    }
} // layer module










@layer app {
.account-create-label {
            gap: $size-10;
            padding: 0;
    }

.account-create-header {
            margin-bottom: $size-20;
            padding-right: $size-40;
    }

.account-create-form {
            margin: 0;
    }

.account-close-identity {
            gap: $size-8;
    }

.account-close-body {
            margin-bottom: $size-18;
    }

.account-close-consequences {
            gap: $size-8;
            margin: 0;
            padding-left: $size-18;
    }

.account-create-label p {
            font-size: var(--font-size-base);
            line-height: $size-17;
    }

.account-create-title {
            font-style: normal;
    }

.account-close-identity strong {
            color: var(--text-primary);
            font-weight: 600;
    }

.account-close-consequences {
            color: var(--text-body);
            font-size: var(--font-size-base);
            line-height: 1.5;
    }

.account-close-consequences li::marker {
            color: var(--color-error-text);
    }
} // layer app
